/**
 * カルテ記入欄の注釈（プレースホルダ）文言。
 *
 * 報告書記入（views/pages/Counselor/Report.vue）と予約時点（同 History.vue）の 2 画面で
 * 同じ文言を出すため、ここを唯一の出所にする（片方だけ直して食い違うのを防ぐ）。
 *
 * 表示は textarea に重ねたオーバーレイ（.placeholderDiv）で、textarea の高さとは連動しない。
 * ＝ 行を増減したら消費側の rows も対で見直すこと（あふれた分は overflow:hidden で見切れる）。
 * 企業版 16 行は rows=23、学校版 17 行は rows=24 で収まることを Chromium / Firefox で実測済み
 * （必要最小はそれぞれ 22 / 23。Chromium 基準に 1 行の余裕を足した値）。
 *
 * 注釈の構成（●本人確認の方法／●項目別／●引き継ぎ事項）は指示書どおり全組織で共通にし、
 * 本人確認の例示に出す身分証だけを組織区分で替える（学校=生徒手帳／非学校=社員証）。
 * 学校版は保護者・教職員の来談があるため本人確認の例が 1 行多い。
 */

export const KARTE_NOTE_SCHOOL = [
  'カルテ記入欄',
  '●本人確認の方法',
  '[例]',
  '・当医師より生徒手帳にて本人確認済',
  '・当心理士より生徒手帳忘れにより学校名・氏名の口頭確認　*生徒手帳の提示がない場合。「報告書」冒頭にも記載',
  '・保護者/教職員のため学校名・氏名にて本人確認済',
  '',
  '●項目別',
  '[例]',
  '【主訴】',
  '【相談内容】',
  '【進路】',
  '【症状/特性】',
  '【見立て/所感】',
  '【今後の対応/方向性】',
  '',
  '●引き継ぎ事項（医師→心理士/心理士→医師）',
].join('\n');

export const KARTE_NOTE_CORPORATE = [
  'カルテ記入欄',
  '●本人確認の方法',
  '[例]',
  '・当医師より社員証にて本人確認済',
  '・当心理士より社員証失念により企業名・部署名・氏名の口頭確認　*社員証提示がない場合。「報告書」冒頭にも記載',
  '',
  '●項目別',
  '[例]',
  '【主訴】',
  '【相談内容】',
  '【進路】',
  '【症状/特性】',
  '【見立て/所感】',
  '【今後の対応/方向性】',
  '',
  '●引き継ぎ事項（医師→心理士/心理士→医師）',
].join('\n');
